import { Button, ButtonCircle } from "@chef/components";
import {
  ProductsByCategoriesQuery,
  ProductsByIdsQuery,
} from "@chef/state-management";
import {
  getStockData,
  getPriceOfProductByVariation,
} from "@chef/state-management/helpers";
import { Minus, Plus } from "@chef/icons/small";
import { useStandaloneBasket } from "@chef/state-management/hooks";

import type { StandaloneBasketVariant } from "@chef/types/basket";

import { intl } from "./StandaloneProductModal.Intl";

interface ControlsProps {
  week: number;
  year: number;
  variation:
    | ProductsByCategoriesQuery["productsByCategories"][number]["products"][number]["variations"][number]
    | ProductsByIdsQuery["products"][number]["variations"][number];
  basketType: StandaloneBasketVariant;
}

export const Controls = ({
  week,
  year,
  variation,
  basketType,
}: ControlsProps) => {
  const { basket, addToBasket, removeFromBasket } = useStandaloneBasket({
    variant: basketType,
    week,
    year,
  });

  const productId = variation.product.productId;
  const variationId = variation.variationId;
  const productTypeId = variation.product.productTypeId;

  const price = getPriceOfProductByVariation(variation);

  const productInBasket = basket?.find((b) => b.variationId === variationId);

  const productCount = productInBasket?.quantity || 0;

  const onDecrementItem = () => {
    removeFromBasket({
      productId,
      productTypeId,
      variationId,
      price,
    });
  };

  const onIncrementItem = () => {
    addToBasket({
      productId,
      productTypeId,
      variationId,
      price,
    });
  };

  const { maxPurchasableAmount } = getStockData({
    addedQuantity: productInBasket?.quantity || 0,
    variation,
  });

  return (
    <div>
      {productCount > 0 && (
        <>
          <ButtonCircle
            className="z-20"
            small
            onClick={onDecrementItem}
            Icon={Minus}
            id={`${variationId}-minus-btn`}
          />
          <span className="mx-2">{productCount}</span>
          <ButtonCircle
            className="z-20"
            small
            primary={productCount > 0}
            onClick={onIncrementItem}
            Icon={Plus}
            disabled={+maxPurchasableAmount === productCount}
            id={`${variationId}-add-btn`}
          />
        </>
      )}

      {productCount === 0 && (
        <Button
          className="z-20"
          IconLeft={Plus}
          onClick={onIncrementItem}
          outlined
          tiny
          secondary
        >
          {intl.ADD}
        </Button>
      )}
    </div>
  );
};
